import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  EntityState,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';
import { History } from '@vk-hr-tek/core/history';

import { ThunkExtra } from '@app/store';
import {
  DashboardService,
  GetUserWidgetQuickActionsParams,
  GetUserWidgetQuickActionsResponse,
} from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../../dashboard.state';
import { setCreateEventData } from '../../../../event-creation/slice';

export const getQuickActions = createAsyncThunk<
  GetUserWidgetQuickActionsResponse,
  GetUserWidgetQuickActionsParams,
  ThunkExtra
>(
  'dashboard/getQuickActions',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getUserWidgetQuickActions({
        params,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const quickAction = createAsyncThunk<
  void,
  {
    type: string;
    companyIds?: string[];
    eventTypeIds?: string[];
    side: string;
  },
  ThunkExtra
>(
  'dashboard/quickAction',
  async (
    { companyIds, type, side, eventTypeIds },
    { rejectWithValue, dispatch, extra: { inject } },
  ) => {
    // const router = inject<EventsRouter>(EventsRouter); //TODO: добавить роутер после возможности добавить в него side
    const history = inject<History>(History);

    try {
      if (type === 'create_event') {
        // router.goToList();
        history.push(`/${side}/events`);

        dispatch(
          setCreateEventData({
            companyIds,
            eventTypeIds,
            modalType: type,
          }),
        );
      }
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const quickActionsReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getQuickActions.pending, (state) => {
    state.quickActions.status = 'loading';
  });
  builder.addCase(getQuickActions.fulfilled, (state, { payload }) => {
    state.quickActions.status = 'complete';
    state.quickActions.companyActions = payload.actions || [];
    state.quickActions.userActions = payload.links || [];
  });
  builder.addCase(getQuickActions.rejected, (state, { payload, error }) => {
    state.quickActions.status = 'failed';
    state.quickActions.error =
      payload ||
      ({
        info: (error && error.message) || 'Unknown error',
        status: 500,
        source: 'client',
        title: 'Internal client error',
      } as AppError);
  });
};
